import { ReactNode } from "react";
import { useUpgradeOptions } from "./hooks/useUpgradeOptions";
import { MobilePlanSelector } from "./components/PlanSelector";
import { useAuth } from "../../../../../apps/web/context/AuthProvider";

interface SubscribeProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- temporary whilst we use the old checkout
  renderCheckout: (props: any) => ReactNode;
  fallback?: () => void;
  callback?: () => void;
  message?: string;
  quota?: any;
  hasSidebar?: boolean;
  from?: string;
}

export function Subscribe({
  fallback,
  callback,
  message,
  from,
}: SubscribeProps) {
  const {
    isLoadingPrices,
    isUpgrading,
    showCheckout,
    checkoutParams,
    currency,
    upgradeOptions,
    handleNewSubscription,
    handleSelectPlan,
  } = useUpgradeOptions({ fallback, callback, from });
  useAuth();

  return (
    <section>
      <>
        <MobilePlanSelector
          upgradeOptions={upgradeOptions}
          currency={currency}
          handleNewSubscription={handleNewSubscription}
          showCheckout={showCheckout}
          checkoutParams={checkoutParams}
          isUpgrading={isUpgrading}
          isLoadingPrices={isLoadingPrices}
          message={message}
          handleSelectPlan={handleSelectPlan}
        />
      </>
    </section>
  );
}
